export const getters = {
  getCalculator: (state) => {
    if (!state.calculator || typeof state.calculator !== 'object') return [];

    const calculationTypeMap = {
      1: 'New Generation',
      2: 'Energy Displacement',
      3: 'Energy Displacement & New Generation',
    };

    return Object.values(state.calculator).map(item => ({
      id: item.projectId,
      date: new Date(item.createdDate).toLocaleDateString('en-GB'),
      calculationType: calculationTypeMap[item.calculationType] || item.calculationType,
      rawCalculationType: item.calculationType, // keep the raw number for API calls
      projectName: item.projectName,
      savings: item.saving15Years,
    }));
  },
  getCalculationResult: (state) => state.calculationResult || null,
};